module.exports = __webpack_public_path__ + "static/media/iPhone.59eedcdc.jpg";